import React from 'react';
import { Pagination, PaginationProps } from 'antd';

import './index.less';

type IIbPaginationProps = PaginationProps;

const MAIN_CLASS_NAME = 'ib-pagination';

const IbPagination: React.FC<IIbPaginationProps> = ({ ...otherProps }) => {
  return <Pagination className={MAIN_CLASS_NAME} {...otherProps} />;
};

export default IbPagination;
